import { styled } from '@material-ui/core';

export const Wrapper = styled('div')(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    position: 'relative',
    minHeight: '100vh',
  },
}));
